import { FormEvent, useState } from 'react';
import { SEOHead } from '../../components/seo/SEOHead';
import { Input, Label } from '../../components/ui/Input';
import { Button } from '../../components/ui/Button';
import { useAuth } from '../../hooks/useAuth';
import { authClient } from '../../lib/auth-client';

export default function Profile() {
  const { user } = useAuth();
  const [name, setName] = useState(user?.name ?? '');
  const [status, setStatus] = useState<'idle' | 'saving' | 'saved' | 'error'>('idle');

  async function handleSubmit(e: FormEvent) {
    e.preventDefault();
    setStatus('saving');
    try {
      await authClient.updateUser({ name });
      setStatus('saved');
    } catch {
      setStatus('error');
    }
  }

  return (
    <>
      <SEOHead title="Profile — Bharat Consultancy" description="" canonicalPath="/dashboard/profile" />

      <h1 className="font-display text-2xl font-bold text-ink">Profile</h1>

      <form onSubmit={handleSubmit} className="mt-6 max-w-md space-y-4 rounded-lg border border-line bg-white p-5">
        <div>
          <Label htmlFor="name">Full Name</Label>
          <Input id="name" value={name} onChange={(e) => setName(e.target.value)} />
        </div>
        <div>
          <Label htmlFor="email">Email</Label>
          <Input id="email" value={user?.email ?? ''} disabled />
        </div>

        <Button type="submit" disabled={status === 'saving'}>
          {status === 'saving' ? 'Saving...' : 'Save Changes'}
        </Button>

        {status === 'saved' && <p className="text-sm text-ledger-green">Profile updated.</p>}
        {status === 'error' && <p className="text-sm text-red-600">Could not save changes.</p>}
      </form>
    </>
  );
}
